<template>
	<div id="videolist">
		<section v-if="videoDataList.length && videoDataList[0].header==1">
			<article style="display: flex;">
				<div class="headLeft" style="width: 480px;height: 360px;overflow: hidden;background-color: #9E9E9E;" v-if="videoDataList.length">
					<div class="leftWarrper" style="display: none;height: 100%;width: 100%;" v-html="videoDataList[0].hyperlink">

					</div>
				</div>
				<div class="headRrght" v-if="videoDataList[0]&&videoDataList[0].category">
					<p v-text="videoDataList[0].category.name" style="margin: 0;font-weight: bold;">所属类别</p>
					<h4 v-text="videoDataList[0].title" class="headTitle"></h4>
					<p v-text="videoDataList[0].summary" style="font-size: 20px;"></p>
					<p class="headTime">
						<img src="../images/icon/time.png" style="vertical-align: middle;margin-right: 10px;width: 33px;" />
						<span v-text="computeTime(videoDataList[0].displayAt)"></span>
						<span v-text="'时长  '+videoDataList[0].second"></span>
					</p>
				</div>
			</article>
			<p>
				<img src="../images/icon/news_line.png" style="width: 100%;" />
			</p>
		</section>
		<!--视频列表-->
		<section id="videoWarpper">
			<div class="videoItem" v-for="item in videoDataList" @click="videoClick(item)">
				<div class="videoImgWarpper">
					<img :src="item.imageUrl" />
				</div>
				<p class="videoCategory" v-text="item.category.name"></p>
				<p class="videoTitle" v-text="item.title" style="-webkit-box-orient: vertical;"></p>
				<p style="margin: 10px 0;position: absolute;bottom: 0;">
					<img src="../images/icon/time.png" style="vertical-align: middle;margin-right: 10px;" /><span v-text="computeTime(item.displayAt)"></span>
				</p>
				<div class="intro">
					<div class="summaryWarpper" v-text="item.summary"></div>
				</div>
				<div class="hoverWarrper">
					打酱油的，勿删
				</div>
			</div>
		</section>
		<section>
			<ul id="pagination">
				<li>
					<a @click="jumpPge('homePage')">首页</a>
				</li>
				<li>
					<a @click="jumpPge('prevPage')">上一页</a>
				</li>
				<li>
					<span style="line-height: 27px;"><i v-text="currentPage">0</i><i>/</i><i v-text="totalPage">0</i></span>
				</li>
				<li>
					<a @click="jumpPge('nextPage')">下一页</a>
				</li>
				<li style="border: none;" @click="jumpPge('lastPage')">
					<a>尾页</a>
				</li>
			</ul>
		</section>
		<!--播放视频-->
		<section id="videoMask" v-show="isSinglePlay">
			<img class="remove" src="../images/icon/close.png" @click="isSinglePlay=!isSinglePlay" />
			<!--<embed src="http://www.feixiong.tv/Public/static/swf/FXPlayerShare.swf?id=1248209" allowFullScreen="true" quality="high" width="720" height="540" align="middle" allowScriptAccess="always" type="application/x-shockwave-flash" style="display: block;margin: 8% auto 0 auto;">-->
		</section>
	</div>
</template>

<script>
	var _this;
	export default {
		name: 'videolist',
		data() {
			return {
				videoDataList: [],
				isSinglePlay: false,
				currentPage: 1, // 当前页码
				rePage:0,  // 请求中的页码
				totalPage: 1, // 总页码
				pageSize: 12, // 一页显示新闻数量

			}
		},
		//监听
		watch: {
			videoDataList: function(d) {
				if(d.length) {
					setTimeout(function() {
						this.videoAnimate();
						$('.leftWarrper iframe,.leftWarrper video,.leftWarrper embed').attr({
							'width': '100%',
							'height': '100%'
						});
						$('.leftWarrper').css('display', 'block');
					}.bind(this), 1000)
				}
			},
			isSinglePlay: function(e) {
				if(e) {
					$('html').css('overflow','hidden');
					$('#videoMask embed').animate({
						'opacity': '1',
						'margin-top': '10%'

					}, 800)
				} else {
					$('html').css('overflow','auto');
					$('#videoMask embed').animate({
						'opacity': '0',
						'margin-top': '8%'
					})
					$('#videoMask>iframe,#videoMask>embed,#videoMask>video').remove();
				}
			}
		},
		//实例加载完成后
		created() {},
		//页面完成以后
		mounted: function() {
			_this = this;
			// 获取视频列表
			this.requestVideoList()

		},

		//事件处理
		methods: {
			// 页码跳转
			jumpPge: function(name) {
				if(name=='homePage'){
					if(this.currentPage==1){
						return;
					}else{
						this.currentPage=1;
						this.rePage=0;
						this.requestVideoList(0);
					}
				}else if(name == 'prevPage'){
					if(this.currentPage<=1){
						this.rePage=0;
						return;
					}else{
						this.currentPage-=1;
						this.rePage-=1;
						this.requestVideoList(this.rePage*this.pageSize);
					}
					
				}else if(name == 'nextPage'){
					if(this.currentPage==this.totalPage){
						this.rePage=this.totalPage-1;
						return;
					}else{
						this.currentPage+=1;
						this.rePage+=1;
						this.requestVideoList(this.rePage*this.pageSize);
					}
				}else if(name == 'lastPage'){
					if(this.currentPage==this.totalPage){
						this.rePage=this.totalPage-1;
						return;
					}else{
						this.currentPage=this.totalPage;
						this.rePage=this.totalPage-1;
						this.requestVideoList(this.rePage*this.pageSize);
					}
				}
			},
			// 时间戳计算
			computeTime: function(d) {
				return this.appfn.creatTime(d).substr(0, 10);
			},
			// 视频聚焦-失焦动画
			videoAnimate: function() {
				$('.videoItem .hoverWarrper').hover(function(e) {
					$(e.currentTarget).prev().css('display', 'block');
					$(e.currentTarget).parent().children().children().first().stop(true, false).animate({
						'zoom': '1.1',
						'left': '-15px',
						'top': '-15px'
					})
					$(e.currentTarget).prev().children().first().animate({'height':'100%'});
					$(e.currentTarget).prev().children().first().slideDown(200);
				}, function(e) {
					$(e.currentTarget).prev().children().first().stop(true, false).slideUp(function() {
						$(e.currentTarget).prev().css('display', 'none');
					}).css('height','0 !important');
					$(e.currentTarget).parent().children().children().first().stop(true, false).animate({
						'zoom': '1',
						'left': '0',
						'top': '0'
					})
				})
			},
			// 播放视频
			videoClick: function(item) {
				$('#videoMask').append(item.hyperlink);
				$('#videoMask>iframe,#videoMask>embed,#videoMask>video').attr('class', 'currentVideo').css({
					'display': 'block',
					'width': '720px',
					'height': '540px',
					'margin': '8% auto 0 auto'
				})
				setTimeout(function() {
					this.isSinglePlay = !this.isSinglePlay
				}.bind(this), 500)
			},
			// ---------------------------------------------------------------------------------------------------
			// 请求视频列表
			requestVideoList: function(offset) {
				this.request.get({
					url: '/edg/video',
					params: {
						'size': this.pageSize,
						'offset': offset ? offset : 0,
					},
					callback: function(d) {
						if(d.total==0){
							$('#pagination').css('display','none');
							return
						}
						this.videoDataList = d.data;
						this.totalPage = Math.ceil(d.total / this.pageSize);
						console.log('请求视频列表：', d, this.videoDataList);
					}.bind(this)
				})

			},

		},

	}
</script>

<style scoped>
	#videolist {
		width: 60%;
		min-width: 1080px;
		margin: 0 auto;
		margin-top: 70px;
		min-height: 700px;
	}
	
	.headRrght {
		box-sizing: border-box;
		padding-left: 70px;
		position: relative;
		width: 529px;
	}
	
	.headRrght .headTitle {
		font-size: 26px;
		font-weight: bold;
		margin: 20px 0;
		color: #333333;
	}
	
	.headRrght .headTime {
		position: absolute;
		bottom: 0;
		right: 0;
		margin-bottom: 0;
	}
	
	#videoWarpper {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}
	
	#videoWarpper .videoItem {
		width: 280px;
		height: 328px;
		margin: 25px;
		position: relative;
		cursor: pointer;
	}
	
	.videoItem .videoCategory {
		margin: 10px 0px;
		width: 100%;
		height: 21px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.videoItem .videoTitle {
		margin: 10px 0;
		font-size: 20px;
		font-weight: bold;
		display: -webkit-box;
		overflow: hidden;
		color: #333333;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	
	.closeBtn:hover {
		zoom: 1.2;
	}
	
	.videoItem .videoImgWarpper {
		width: 280px;
		height: 186px;
		overflow: hidden;
		position: relative;
		background-color: #9e9e9e;
	}
	
	.videoItem .videoImgWarpper>img {
		width: 280px;
		height: 186px;
		position: absolute;
	}
	
	.videoItem .intro {
		width: 100%;
		height: 183px;
		background-color: rgba(0, 0, 0, 0.2);
		margin: 0;
		position: absolute;
		bottom: 143px;
		color: white;
		overflow: hidden;
		display: none;
	}
	
	.videoItem .intro .summaryWarpper {
		width: 100%;
		height: 0;
		display: none;
		font-size: 15px;
		position: absolute;
		bottom: 0;
		box-sizing: border-box;
		padding: 10px 10px 0 10px;
		word-break: break-all;
	}
	
	.videoItem .hoverWarrper {
		position: absolute;
		top: 0;
		width: 100%;
		height: 200px;
		opacity: 0;
	}
	
	.closeBtn {
		position: absolute;
		top: 10px;
		right: 10px;
		cursor: pointer;
	}
	
	.closeBtn:hover {
		zoom: 1.2;
	}
	
	#videoMask {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 9999;
		background-color: rgba(0, 0, 0, 0.4);
	}
	
	#pagination {
		text-align: center;
		font-size: 0;
		padding: 30px 0;
	}
	
	#pagination li {
		display: inline-block;
		font-size: 20px;
		padding: 3px 10px;
		border-right: 1px solid #0f71bb;
		-ms-user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
	}
	
	#pagination li a {
		cursor: pointer;
	}
	
	#pagination li:hover {
		background: #ddd;
	}
</style>


// WEBPACK FOOTER //
// src/components/videolist.vue